export default {"src":"/_next/static/media/apple-pay.d6f7324d.svg","height":14,"width":33,"blurWidth":0,"blurHeight":0};